import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  url, 
  author = 'JODUST',
  publishedTime,
  modifiedTime
}) => {
  const siteTitle = title ? `${title} | JODUST - Alu i PVC stolarija` : 'JODUST - Proizvodnja i montaža ALU i PVC stolarije';
  const siteDescription = description || 'JODUST iz Lebana - profesionalna proizvodnja i montaža ALU i PVC stolarije. Prozori, vrata, klizni sistemi. Kvalitetni materijali, precizna izrada, profesionalna montaža. Poslujemo širom Srbije.';
  const siteImage = image || 'https://www.jodust.rs/og-image.jpg';
  const siteUrl = url || (typeof window !== 'undefined' ? `https://www.jodust.rs${window.location.pathname}` : 'https://www.jodust.rs');

  return (
    <Helmet>
      {/* Osnovni meta tagovi */}
      <title>{siteTitle}</title>
      <meta name="description" content={siteDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content={author} />
      <meta name="copyright" content={`Copyright © ${new Date().getFullYear()} JODUST`} />
      <link rel="canonical" href={siteUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={siteDescription} />
      <meta property="og:image" content={siteImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="JODUST" />
      <meta property="og:locale" content="sr_RS" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={siteDescription} />
      <meta name="twitter:image" content={siteImage} />

      {/* SEO za Srbiju */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="Serbian" />
      <meta name="geo.region" content="RS" />
      <meta name="geo.placename" content="Lebane" />
      <meta name="geo.position" content="42.9200;21.7380" />
      <meta name="ICBM" content="42.9200, 21.7380" />
      
      {/* Revisit after */}
      <meta name="revisit-after" content="7 days" />

      {/* Schema.org markup za organizaciju */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "JODUST",
          "url": "https://www.jodust.rs",
          "logo": "https://www.jodust.rs/logo.png",
          "image": siteImage,
          "description": siteDescription,
          "email": "office@jodust.rs",
          "telephone": "+3813737336",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Svetog Save 13",
            "addressLocality": "Lebane",
            "postalCode": "16230",
            "addressCountry": "RS"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "42.9200",
            "longitude": "21.7380"
          },
          "priceRange": "$$",
          "openingHours": "Mo-Fr 08:00-16:00, Sa 08:00-14:00",
          "areaServed": [
            {
              "@type": "City",
              "name": "Leskovac"
            },
            {
              "@type": "City",
              "name": "Lebane"
            },
            {
              "@type": "State",
              "name": "Srbija"
            }
          ]
        })}
      </script>

      {publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}
      {modifiedTime && (
        <meta property="article:modified_time" content={modifiedTime} />
      )}
    </Helmet>
  );
};

export default SEO;